export const abortTimeout = (timeoutMs) => {
    if (!timeoutMs)
        return { timeout: null, signal: null };
    const controller = new AbortController();
    const { signal } = controller;
    const timeout = setTimeout(() => {
        controller.abort();
    }, timeoutMs);
    return {
        timeout,
        signal,
    };
};
